@if (!loading) {
  <app-provider-header [provider]="provider" />
  <div class="mt-3">
    <app-provider-captures-search-settings [provider]="provider" (settingsChange)="onSettingsChange($event)" />
    @if (!loadingCaptures) {
      <div class="mt-2">
        @if (captureQueueResults.length > 0) {
          <app-capture-queue-results
            [captureQueueResults]="captureQueueResults"
            [displayProvider]="false"
            [openInNewTab]="true" />
          @if (hasMoreCaptures) {
            <div class="text-center mb-4">
              <a href="#next" (click)="onNextClick($event)" class="load-next-captures">
                View Next {{ limit }} Captures
              </a>
            </div>
          }
        } @else {
          <div class="p-2">No captures found. Try modifying the filters.</div>
        }
      </div>
    } @else {
      <div class="mt-2"><mat-spinner /></div>
    }
  </div>
} @else {
  <mat-spinner />
}
